import { useEffect, useRef } from "react";
import { registerDockHost } from "./dock-store";

/**
 * A place inside an open sheet for the docked WhatsApp panel to render into
 * (dock-store.ts says why). `display: contents`, so it takes no room and adds
 * no gap to the sheet's own layout; the panel inside it is `fixed`.
 */
export function DockHost() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    return registerDockHost(element);
  }, []);
  return <div ref={ref} className="contents" data-whatsapp-dock-host="" />;
}
